(function($) {
    'use strict';

    $(document).ready(function() {

        // Pour chaque bloc produits sur la page
        $('.bloc_produits').each(function() {
            var $bloc = $(this);
            var $sommaireItems = $bloc.find('.sommaire ul li');
            var $produits = $bloc.find('.produits .produit');

            // Vérifier qu'on a le même nombre d'items
            if ($sommaireItems.length !== $produits.length) {
                console.warn('Le nombre d\'items du sommaire ne correspond pas au nombre de produits');
                return;
            }

            // Masquer tous les produits sauf le premier
            $produits.hide().first().show();

            // Ajouter la classe active au premier item du sommaire
            $sommaireItems.first().addClass('active');

            // Gérer le clic sur les items du sommaire
            $sommaireItems.on('click', function() {
                var index = $(this).index();

                // Retirer la classe active de tous les items
                $sommaireItems.removeClass('active');

                // Ajouter la classe active à l'item cliqué
                $(this).addClass('active');

                // Masquer tous les produits
                $produits.fadeOut(300);

                // Afficher le produit correspondant
                setTimeout(function() {
                    $produits.eq(index).fadeIn(400);
                }, 300);
            });

            // Ajouter un curseur pointer pour indiquer que c'est cliquable
            $sommaireItems.css('cursor', 'pointer');
        });

    });

})(jQuery);